'use client';

import { useEffect } from 'react';

import { AlertTriangle, RefreshCw } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Link } from '@/i18n/routing';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function BookError({ error, reset }: ErrorProps) {
  useEffect(() => {
    console.error('Booking page error:', error);
  }, [error]);

  return (
    <div className='flex min-h-screen items-center justify-center bg-white px-4'>
      <div className='flex flex-col items-center space-y-6 text-center max-w-md'>
        <div className='flex flex-col items-center space-y-4'>
          <AlertTriangle className='h-12 w-12 text-destructive' aria-hidden />
          <h1 className='text-2xl font-bold'>Booking form unavailable</h1>
          <p className='text-muted-foreground'>
            Something went wrong while loading the booking form. Please try again or choose a
            service from the homepage.
          </p>
        </div>

        <div className='flex flex-col sm:flex-row gap-3 w-full sm:w-auto'>
          <Button onClick={reset} className='flex items-center justify-center gap-2'>
            <RefreshCw className='h-4 w-4' />
            Try again
          </Button>
          <Button variant='outline' asChild>
            <Link href='/'>Go to homepage</Link>
          </Button>
        </div>

        <details className='mt-4 w-full text-left'>
          <summary className='cursor-pointer text-sm text-muted-foreground'>Error details</summary>
          <pre className='mt-2 whitespace-pre-wrap break-words text-xs text-muted-foreground bg-muted/50 p-3 rounded'>
            {error.message}
            {error.stack && `\n\n${error.stack}`}
          </pre>
        </details>
      </div>
    </div>
  );
}
